import React from 'react'
let T = {}
let script = undefined
let lang = ''
let callbacks = []

let onUpdate = () => {
    callbacks.forEach(callback => {
        callback(lang)
    })
}

T.setLanguage = (language) => {
    
    if(language === lang) return 

    switch (language) {
        case 'pt-BR':
            language = 'pt-BR'
            break
        case 'pt':
            language = 'en-US'
            break
        case 'en':
            language = 'en-US'
            break
        case 'en-US':
            language = 'en-US'
            break
        default:
            language = 'en-US'
            break
    }

    lang = language

    import(`./languages/${language.toLowerCase()}.json`)
    .then(resp  => {
        script = resp
        onUpdate()
    })

    return lang
}

T.getLanguage = () => lang

T.getIndex = (index) => {
    if(!script) return
    let text = script[index] ? script[index] : `{{[${index}][${lang}]}}`
    return text
}

T.text = (index, data = {}) => {
    let text = T.getIndex(index)
    
    for(var key in data) {
        let regex = new RegExp("{{"+key+"}}", "g");
        text = text.replace(regex, data[key]);
    }

    return <span dangerouslySetInnerHTML={{__html: text}} />
}

//to-do remover quando não mais usado
T.pattern = (index, data = {}) => T.text(index, data)

T.txt = (index, data = {}) => {
    let text = T.getIndex(index)

    for(var key in data) {
        let regex = new RegExp("{{"+key+"}}", "g");
        text = text.replace(regex, data[key]);
    }

    return text
}

T.handleUpdate = (callback) => {
    callbacks.push(callback)
}


export default T



// WEBPACK FOOTER //
// ./src/translate/T.js